import React from 'react';

interface HeroBannerProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  altText?: string;
  customClass?: string;
}

const HeroBanner: React.FC<HeroBannerProps> = ({ title, subtitle, imageUrl, altText = '', customClass = '' }) => {
  return (
    <div className={`wp-block-k12-section container-fluid rounded-top-corners ${customClass}`}>
      <div className="row">
        <div className="col-12 g-0">
          <div className="wp-block-k12-hero">
            <div className="row no-wrap">
              <div className="col-sm-12 col-md-6 col-xl-6 text-start align-self-center">
                <h1>{title}</h1>
                <p className="heading-4">{subtitle}</p>
              </div>
              <div className="col-sm-12 col-md-6 col-xl-6 justify-content-center d-flex">
                <img
                  src={imageUrl}
                  alt={altText}
                  className="wp-image-438 img-fluid"
                />
                <div className="circle-background"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
